import styled from 'styled-components'

export const LevelCompleteBannerContainer = styled.div`
  width: 100%;
  padding: 24px 16px;
  background: #F0FFF4;
  border-radius: 8px;
  border: 1px solid rgba(43.80, 162, 74.54, 0.25);
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const LevelCompleteBannerHeader = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
`

export const CheckIconWrapper = styled.div`
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const LevelCompleteBannerTitle = styled.div`
  color: #00234B;
  font-size: 14px;
  font-family: 'Montserrat', sans-serif;
  font-weight: 600;
  line-height: 18px;
  text-align: center;
`

export const LevelCompleteBannerMessage = styled.div`
  color: #00234B;
  font-size: 12px;
  font-family: 'Montserrat', sans-serif;
  font-weight: 400;
  line-height: 15px;
  text-align: center;
`

